import { EmptyPageWrapper, EmptyPageHeading } from './ErrorOnboarding.styles';

interface IErrorOnboarding {
  message: string;
}

const ErrorOnboarding = ({ message }: IErrorOnboarding) => {
  return (
    <EmptyPageWrapper>
      <EmptyPageHeading>{message}</EmptyPageHeading>
    </EmptyPageWrapper>
  );
};

export { ErrorOnboarding };
